import { Component, Inject, Vue } from 'vue-property-decorator';
import JunkItHeader from '@/components/header/junk-it-header.vue'
import ResetKey from '@/components/registration/reset-key.vue'
import JunkItFooter from '@/components/footer/junk-it-footer.vue'

@Component({
    components: {
        JunkItHeader,
        ResetKey,
        JunkItFooter,
    },
})
export default class ResetKeyComponent extends Vue {
}
